import { useEffect, useState } from 'react';
function useIsClient() {
    var _a = useState(false), isClient = _a[0], setClient = _a[1];
    useEffect(function () {
        setClient(true);
    }, []);
    return isClient;
}
export default useIsClient;
//# sourceMappingURL=useIsClient.js.map